<template>
    <div id="app" class="dx-viewport">
        <component :is="route.meta.layout">
            <router-view></router-view>
        </component>
    </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
const route = useRoute()
</script>

<style>
* { box-sizing: border-box; }

html, body {
    margin: 0;
    padding: 0;
    font-family: Montserrat, "Helvetica Neue", "Segoe UI", Helvetica, Verdana, sans-serif;
    width: 100%;
    max-width: 100vw;
}

#app {
    min-height: 100vh;
    width: 100%;
    max-width: 100vw;
}

.dx-viewport {
    background-color: var(--dx-color-main-bg);
    min-height: 100vh;
    max-width: 100vw;
}
</style>
